'use client';

import { c as _c } from "react/compiler-runtime";
import type { KeenSliderInstance } from 'keen-slider/react';
import type { RefObject } from 'react';
import { useCallback, useEffect, useLayoutEffect, useState } from 'react';
export const useRailArrowPosition = (instanceRef, containerRef, setHideLeft, setHideRight) => {
  const $ = _c(12);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      vertical: 0
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [arrowPosition, setArrowPosition] = useState(t0);
  let t1;
  if ($[1] !== containerRef || $[2] !== instanceRef || $[3] !== setHideLeft || $[4] !== setHideRight) {
    t1 = () => {
      const firstImage = containerRef.current?.querySelector(".keen-slider__slide img");
      if (!firstImage || !containerRef.current || !instanceRef.current) {
        return;
      }
      const imageHeight = firstImage?.offsetHeight;
      setArrowPosition({
        vertical: imageHeight ? imageHeight / 2 + 10 : 0
      });
      setHideLeft(instanceRef.current?.track.details.rel === 0);
      setHideRight(instanceRef.current?.track.details.maxIdx === instanceRef.current?.track.details.rel);
    };
    $[1] = containerRef;
    $[2] = instanceRef;
    $[3] = setHideLeft;
    $[4] = setHideRight;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const updateSize = t1;
  let t2;
  let t3;
  if ($[6] !== updateSize) {
    t2 = () => {
      const onLayoutChange = () => requestAnimationFrame(updateSize);
      window.addEventListener("resize", onLayoutChange);
      window.addEventListener("scroll", onLayoutChange);
      return () => {
        window.removeEventListener("resize", onLayoutChange);
        window.removeEventListener("scroll", onLayoutChange);
      };
    };
    t3 = [updateSize];
    $[6] = updateSize;
    $[7] = t2;
    $[8] = t3;
  } else {
    t2 = $[7];
    t3 = $[8];
  }
  useLayoutEffect(t2, t3);
  let t4;
  let t5;
  if ($[9] !== updateSize) {
    t4 = () => {
      setTimeout(() => {
        updateSize();
      }, 1);
    };
    t5 = [updateSize];
    $[9] = updateSize;
    $[10] = t4;
    $[11] = t5;
  } else {
    t4 = $[10];
    t5 = $[11];
  }
  useEffect(t4, t5);
  return arrowPosition;
};